import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { UserInformation } from "../models/UserInformation";

interface CheckoutMessageBarMessageBarProps {
  checkedOutTo: UserInformation;
}

export const CheckoutMessageBar = (
  props: CheckoutMessageBarMessageBarProps
) => {
  const { checkedOutTo } = props;
  const { t } = useTranslation();

  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>{t("checkedOutToMessageBarTitle")}</MessageBarTitle>
        {t("checkedOutToMessageBarText") + checkedOutTo.displayName}
      </MessageBarBody>
    </MessageBar>
  );
};
